<h2 mat-dialog-title>Alterar CNPJ e token</h2>

<mat-dialog-content>
    <p class="texto-apoio">O CNPJ e o token são testados juntos com o IBPT antes de serem salvos. Depois de salvo, o token não é exibido por completo.</p>

    <form [formGroup]="model" (ngSubmit)="testarESalvar()" id="formAlterarCredencialIbpt">
        <mat-form-field appearance="outline">
            <mat-label>CNPJ de consulta</mat-label>
            <input matInput formControlName="cnpj" type="text" class="cnpj" [mask]="masks.cnpj" />
            @if (model.get('cnpj')?.invalid) {
                <mat-error>Informe um CNPJ válido.</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Novo token de integração</mat-label>
            <input matInput formControlName="token" type="password" autocomplete="new-password" placeholder="Cole o token gerado no De Olho no Imposto" />
            @if (model.get('token')?.invalid) {
                <mat-error>Informe o novo token.</mat-error>
            }
        </mat-form-field>
    </form>

    <p class="texto-apoio">
        @if (data.finalToken) {
            Token atual termina em {{ data.finalToken }}.
        }
        A alteração fica registrada com seu nome.
    </p>
</mat-dialog-content>

<mat-dialog-actions class="action-buttons">
    <button type="button" mat-flat-button class="btn-secundary" [disabled]="isTestando" (click)="cancelar()">Cancelar</button>
    <button type="submit" form="formAlterarCredencialIbpt" mat-flat-button class="btn-primary" [disabled]="isTestando">
        @if (isTestando) {
            <mat-spinner [diameter]="20" class="mat-spinner-btn"></mat-spinner>
            Testando…
        } @else {
            Testar e salvar
        }
    </button>
</mat-dialog-actions>
